import ComingSoon from "@/components/common/ComingSoon";
import PageLayout from "@/components/layout/PageLayout";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { Trans } from "@lingui/react";
import { createFileRoute } from "@tanstack/react-router";
import CopyTradingGuides from "./-components/CopyTradingGuides";
import CopyTradingStatsCard from "./-components/CopyTradingStatsCard";

export const Route = createFileRoute("/_main/copy-trading/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleCopyTrading),
      },
    ],
  }),
  component: CopyTradingPage,
});

function CopyTradingPage() {
  return (
    <PageLayout>
      <ComingSoon>
        <div className="p-2 md:p-[70px]">
          <section className="z-20 flex max-w-[1488px] flex-col items-start justify-start gap-8 [&>*]:z-20">
            <div className="flex flex-col items-start gap-4">
              <h1 className="text-4xl font-medium">
                <Trans
                  id="copyTrading.page.heading"
                  message="Copy Trading Classic"
                  comment="Primary heading describing the copy trading classic section."
                />
              </h1>
              <p className="text-gray-p text-base md:text-center">
                <Trans
                  id="copyTrading.page.subtitle"
                  message="Unlock Top Traders, Achieve Champion Profits"
                  comment="Tagline encouraging users to explore copy trading."
                />
              </p>
            </div>
            <div className="flex w-full flex-col gap-1.5">
              <CopyTradingStatsCard totalAssets={100000} pnl={10000} />
              <CopyTradingGuides />
            </div>
          </section>
        </div>
      </ComingSoon>
    </PageLayout>
  );
}
